var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[(!_vm.formCompleted || _vm.retake)?_c('onboard-author-publisher',{ref:"form"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }